import { atom } from 'recoil';
import UserManager from '../../../shared/user-manager';

const $isUserLogin = atom<boolean>({
    key: '@login/is-user-login',
    default: new UserManager().isLogin(),
});

export default $isUserLogin;
